<template>
	<div class="" style="background: #f1f1f1;">
		<!--头部-->
		<Header @toggleLang="toggleLang"></Header>
		<div class="layout m-newList">
			<div class="list_count no-padding-top">
				<div class="wow fadeInUp animated ">
					<img class="list_img css3" :src="zidiyiData.publicBg.files" />
				</div>
				<div class="list_info">
					<div class="info_tit wow fadeInUp animated" data-wow-delay="0.5s" data-wow-offset='0'>
						<div class="tit_left">
							<span>刊物列表</span>
							<el-divider direction="vertical"></el-divider>
							<span>PUBLICTIONS</span>
						</div>
					</div>


					<!-- 列表 -->
					<div class="liebiao_list wow fadeInUp animated" data-wow-delay="0.5s" data-wow-offset='0'>


						<div class="row" v-if="arcList.length>0">

							<div class="item   wow fadeInUp animated" v-for="(item,index) in arcList"
								@click="go_album(item.id)" :key="item.id">
								<div class="photos video-photo">
									<img class="photo" :src="item.image" />
								</div>
								<div class="info">
									<div class="title line-2">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
									<div class="time">{{lang=='CN' ?item.cn_digest:item.en_digest}}</div>
								</div>

							</div>
						</div>
						<div class="row" v-else>
							暂无数据~
						</div>

						<!-- 分页 -->
						<div class="fenye">
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="currentPage4" background :page-size="per_page"
								layout="total, prev, pager, next, jumper" :total="total">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header'
	import Footer from '@/components/Footer'
	import {
		channel_list,
		add_pv,
		get_banner,
		archives_list,
		get_file_all
	} from '@/api/api.js'
	import {
		WOW
	} from 'wowjs'
	export default {
		components: {
			Header,
			Footer
		},
		name: 'new_list',
		data() {
			return {
				index: 0,
				arcList: [], //内容列表
				currentPage4: 1,
				parent_id: 10,
				list: [], //
				jx_index: 29,
				per_page: 9,
				page: 1,
				zidiyiData: {
					publicBg: {
						files: ''
					}
				},
				total: 0,
				lang: localStorage.getItem('lang') || 'CN',
			}
		},
		created() {
			this.parent_id = this.$route.query.parent_id
			if (this.$route.query.index) {
				this.index = this.$route.query.index
			}
			this.getZidiyiData() //自定义图片

			this.getArchivesList(70)


			var wow = new WOW({
				boxClass: 'wow',
				animateClass: 'animated',
				offset: 0,
				mobile: true,
				live: true
			});
			wow.init();
			localStorage.setItem('current', 2)
		},
		mounted() {

		},
		methods: {
			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},




			go_album(id) {

				this.$router.push({
					path: `photo?id=${id}`
				})
			},


			go_open(url) {
				if (url) {
					window.open(url, "_blank");
				}
			},
			getArchivesList(id) {
				let data = {
					channel_id: id,
					per_page: this.per_page,
					page: this.page,
				}

				this.$axios.get("/api/jx/archives_list", {
					params: data
				}).then((res) => {

					if (res.data.code == 1) {
						this.arcList = res.data.data.data
						console.log(res.data.data.total, 999);
						this.total = res.data.data.total
					}
				}).catch(err => {});
			},

			// 获取自定义图片
			getZidiyiData() {
				let data = {
					channel_id: 47,
					per_page: this.per_page,
					page: this.page
				}
				get_file_all(data).then((res) => {
					this.zidiyiData = res.data
				}).catch(err => {});
			},
			choose_type(num) {
				this.index = num
				let new_http = window.location.origin
				if (new_http == this.prod) {
					new_http = this.prod+'/web/'
				}
				let url = new_http + `#/new_list?parent_id=10&index=${this.index}`
				window.history.replaceState(null, '', url);
				this.jx_index = this.list[this.index].id
				this.getArchivesList(this.list[this.index].id)
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				this.page = val
				this.getArchivesList(this.jx_index)
				console.log(`当前页: ${val}`);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.css3 {
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
	}

	.m-newList {
		background: #fff;

		.list_count {
			padding: 30px;
		}

		.list_info {
			margin: 50px auto;
			max-width: 1400px;

			.list_img {
				width: 100%;
			}
		}

		.info_tit {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;

			.active {
				border: 2px solid #006170;
				box-shadow: 5px 7px 10px #cddadc;
				color: #000;
			}
		}

		.tit_left {
			span:first-child {
				font-size: 30px;
				color: #000;
				font-weight: bold;
			}
		}

		.hover_span {
			cursor: pointer;
		}

		.liebiao_list {
			margin-top: 20px;
		}


		.row {
			margin: 0px;
		}

		.tit_right:hover {
			opacity: .8;
			cursor: piinter
		}

		.item {
			width: 320px;
			overflow: hidden;
			position: relative;
			margin-bottom: 10px;
			float: left;
			margin: 0 0 30px 40px;
			cursor: pointer;
			&:nth-child(4n+1) {
				margin-left: 0px;
			}
			.photos {
				width: 100%;
				height: 450px;
				position: relative;

				.photo {
					width: 100%;
					object-fit: cover;
					height: 100%;
				}
			}

			.info {
				font-size: 24px;
				margin-top: 25px;
			}

			.tit_left {
				float: left
			}

			.time {
				margin-top: 10px;
				color: #666666;
				font-size: 14px;
			}
		}

		.info_tit {
			margin-bottom: 37px;
			overflow: hidden;
		}

		.pointer_img:hover {
			transform: scale(1.2);
			overflow: hidden;
		}

	}

	.fenye {
		margin-top: 50px;
		text-align: center;
	}

	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006170;
	}


	.btn-next {
		width: 30px
	}

	@media screen and (max-width: 1400px) {
		.m-newList .list_info {
			width: 100%;
		}
	}
</style>
